export var KlevuSearchSorting;
(function (KlevuSearchSorting) {
    /**
     * This is the default sort order, which uses a combination of Klevu A.I. and
     * your own merchandising configuration to determine the order of the results.
     * Please read this article for more information about how Klevu ranks and
     * orders the results.
     */
    KlevuSearchSorting["Relevance"] = "RELEVANCE";
    /**
     * Sort the results by the salePrice value of each record.
     */
    KlevuSearchSorting["PriceAsc"] = "PRICE_ASC";
    /**
     * Sort the results by the salePrice value of each record.
     */
    KlevuSearchSorting["PriceDesc"] = "PRICE_DESC";
    /**
     * Sort the results by the name of each record, in alphabetical order.
     */
    KlevuSearchSorting["NameAsc"] = "NAME_ASC";
    /**
     * Sort the results by the name of each record, in alphabetical order.
     */
    KlevuSearchSorting["NameDesc"] = "NAME_DESC";
    /**
     * Sort the results by each record's average rating, if this data has been
     * indexed in your store.
     */
    KlevuSearchSorting["RatingAsc"] = "RATING_ASC";
    /**
     * Sort the results by each record's average rating, if this data has been
     * indexed in your store.
     */
    KlevuSearchSorting["RatingDesc"] = "RATING_DESC";
    /**
     * Sort your records based on their published date. Please see support article
     * for important information about sorting by newness.
     */
    KlevuSearchSorting["NewArrivalAsc"] = "NEW_ARRIVAL_ASC";
    /**
     * Sort your records based on their published date. Please see support article
     * for important information about sorting by newness.
     */
    KlevuSearchSorting["NewArrivalDesc"] = "NEW_ARRIVAL_DESC";
})(KlevuSearchSorting || (KlevuSearchSorting = {}));
